import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect, useState } from 'react'
import { reportService } from '../services/reportService'
import { startOfMonth, endOfMonth } from 'date-fns'
import { ReportCustomersParams } from '../services/reportService/reportCustomers'

export const useReportCustomers = () => {
  const [params, setParams] = useState<ReportCustomersParams | undefined>({
    transactionStartDate: startOfMonth(new Date()).toISOString(),
    transactionEndDate: endOfMonth(new Date()).toISOString(),
  })
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['reportCustomers', params],
    queryFn: async () => reportService.reportCustomers(params),
    placeholderData: keepPreviousData,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
  }
}
